module.exports = __webpack_public_path__ + "img/buger-photo.d144607a.png";